// Functions to consume api

import { ApiModule } from "@api/src/ApiModule"

let url = process.env.MIX_APP_URL

export class Request extends ApiModule {
  constructor(props) {
    super(props)

    // this.adminUrl = process.env.MIX_APP_URL
  }

  // get headers() {
  //   const token = Ambition.getGlobal("tenant.token")
  //   if (!token) throw Error("Request [token] is not defined.")
  //   return { Authorization: `Bearer ${token}` }
  // }

  mergePlaceholders(endpoint) {
    const placeholders = {
      "{application}": this.getGlobal("tenant.applicationId"),
      "{admin_url}": this.getGlobal("tenant.admin_url")
    }
    Object.keys(placeholders).forEach((placeholder, i) => {
      const value = Object.values(placeholders)[i]
      endpoint = endpoint.replace(placeholder, value)
    })
    return endpoint
  }

  /**
   * Make API Calls
   *
   * @usage
   *    Ambition.Request.call({ url, method, data })
   * @example
   *    Ambition.Request.call({}).then((e) => { console.log(e.data) })
   */
  async call(options, optional_token = false) {
    const defaults = {
      url: "/api/test-status/200",
      method: "GET",
      data: {},
      params: {}
    }
    const settings = Object.assign(defaults, options)

    // settings.headers = this.headers

    // console.warn('Request.call', options)
    // console.warn("Request.call", window.$store.getters.adminToken)

    if (optional_token) {
      settings.headers = { Authorization: `Bearer ${optional_token}` }
    } else if (options.admin) {
      const adminToken = window.$store.getters.adminToken
      settings.headers = { Authorization: `Bearer ${adminToken}` }
    } else {
      const tenantToken = Ambition.getGlobal("tenant.token")
      settings.headers = { Authorization: `Bearer ${tenantToken}` }
    }

    settings.url = this.mergePlaceholders(settings.url)

    return await axios(settings)
  }
}
